import styled from "styled-components";
import AntBreadCrumbs from "uiKits/BreadCrums";
import { CONTENT_WIDTH, media, PAGE_GUTTER } from "@/theme/breakpoints";

export const PageRoot = styled.div`
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  box-sizing: border-box;
`;

export const StyledBreadCrumbs = styled(AntBreadCrumbs)`
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  margin: 0 auto;
  display: block;
  box-sizing: border-box;
  padding-left: ${PAGE_GUTTER.desktop}px;
  padding-right: ${PAGE_GUTTER.desktop}px;

  ${media.downTablet`
    width: 100%;
    padding-left: ${PAGE_GUTTER.tablet}px;
    padding-right: ${PAGE_GUTTER.tablet}px;
  `}

  ${media.downMobile`
    padding-left: ${PAGE_GUTTER.mobile}px;
    padding-right: ${PAGE_GUTTER.mobile}px;
  `}
`;

export const MainHeading = styled.h2`
  color: var(--Text2, #000);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  padding-left: ${PAGE_GUTTER.desktop}px;
  padding-right: ${PAGE_GUTTER.desktop}px;

  ${media.downTablet`
    width: 100%;
    font-size: 26px;
    padding-left: ${PAGE_GUTTER.tablet}px;
    padding-right: ${PAGE_GUTTER.tablet}px;
  `}

  ${media.downMobile`
    font-size: 22px;
    padding-left: ${PAGE_GUTTER.mobile}px;
    padding-right: ${PAGE_GUTTER.mobile}px;
  `}
`;
